export default "__VITE_ASSET__BnOhxjdV__"